import { useMemo } from 'react'
import { MRT_ColumnDef } from 'material-react-table'
import { Box } from '@mui/material'
import { QueryKey } from '@tanstack/react-query'
import { ProjectTag } from '@/types/project-tags'
import TagChip from '../tags/TagChip'
import useZerapixTable from '../zerapix-table/useZerapixTable'
import ZerapixTable from '../zerapix-table/ZerapixTable'
import TagActionsMenu from './TagActionsMenu'
import TagCount from './TagCount'

type TagsListProps = {
  projectTags: ProjectTag[]
  listQueryKey: QueryKey
}

export default function TagsList({ projectTags, listQueryKey }: TagsListProps) {
  const columns = useMemo<MRT_ColumnDef<ProjectTag>[]>(() => {
    return [
      {
        header: 'Tag',
        accessorKey: 'name',
        Cell: ({ row }) => {
          return (
            <Box sx={{ py: 1 }}>
              <TagChip tag={row.original} />
            </Box>
          )
        },
      },
      {
        header: 'Documents',
        Cell: ({ row }) => {
          return <TagCount projectTag={row.original} />
        },
      },
    ]
  }, [])

  const table = useZerapixTable({
    data: projectTags,
    columns,
    enableRowActions: true,
    // The page heading names the table and holds the New tag button
    enableTopToolbar: false,
    muiTableBodyCellProps: {
      sx: {
        py: 1,
        px: 2,
      },
    },
    renderRowActions: ({ row }) => {
      return (
        <TagActionsMenu projectTag={row.original} listQueryKey={listQueryKey} />
      )
    },
  })

  return <ZerapixTable<ProjectTag> table={table} />
}
